import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationLearners.vue?vue&type=template&id=5c1a6df2"
import script from "./EnacAtplDashboardRegistrationLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports